import { Fragment } from "react";
import { Grid } from "@mui/material";

import { Label, TextField } from "../../../components";

export default function FormOne({ formData }) {
  return (
    <Fragment>
      <Grid item xs={6}>
        <Label title="Company Name" />

        <TextField
          size="small"
          name="companyName"
          placeholder="Company Name"
          value={formData.companyName}
          disabled
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Company Contact" />

        <TextField
          size="small"
          name="companyContact"
          placeholder="Company Contact"
          value={formData.companyContact}
          disabled
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Business Nature" />

        <TextField
          size="small"
          name="companyNatureBusiness"
          placeholder="Business Nature"
          value={formData.companyNatureBusiness}
          disabled
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Company Director's Name" />

        <TextField
          size="small"
          name="companyDirectorsName"
          placeholder="Company Director's Name"
          value={formData.companyDirectorsName}
          disabled
        />
      </Grid>
    </Fragment>
  );
}
